// infrastructure/mappers/load.mapper.ts

import { loadTransists } from '../../domain/TransitsData';
import { LoadDTO } from '../dto/TransitsDTO';

export interface LoadData extends Omit<LoadDTO, 'id'> {
  code: string;
  provider_id: number;
  provider_tier: string;
}

export interface LoadDataEdit extends LoadDTO {
  code: string;
  provider_id: number;
  provider_tier: string;
}

export interface LoadDataToBack extends Omit<LoadDTO, 'id'> {
  code: string;
  provider_id: number;
  provider_tier: string;
}
export class LoadMapper {
  private static formatToISO(dateStr: string): string {
    const [datePart, timePartWithH] = dateStr.split(' ');
    const [day, month, year] = datePart.split('/');
    const timePart = timePartWithH.replace('h', '');

    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(timePart.split(':')[0]),
      Number(timePart.split(':')[1])
    );

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}T${hh}:${min}:00`;
  }

  private static formatDateTime(value: string): { hour: string; date: string } {
    const cleanValue = value.replace('h', '');

    const dateObj = new Date(cleanValue);

    // Formatear hora → hh:mmh
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const hourFormatted = `${hours}:${minutes}h`;

    // Formatear fecha → dd/MM/yyyy
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    const dateFormatted = `${day}/${month}/${year}`;

    return {
      hour: hourFormatted,
      date: dateFormatted
    };
  }
  static toCreateDTO(domain: LoadData): LoadDataToBack {
    return {
      code: domain.code,
      provider_id: domain.provider_id,
      provider_tier: domain.provider_tier,
      plate_number: domain.plate_number,
      delivery_time: this.formatToISO(domain.delivery_time),
      quantity: domain.quantity,
      provider_delivery_note: domain.provider_delivery_note
    };
  }
  static toDomain(dto: LoadDataEdit): loadTransists {
    return {
      id: dto.id,
      amount: dto.quantity,
      deliveryTime: dto.delivery_time,
      deliveryTimeDate: dto.delivery_time,
      providerDeliveryNote: dto.provider_delivery_note,
      plateNumber: dto.plate_number
    };
  }
  static toTransit(dto: LoadDTO): loadTransists {
    const { hour, date } = this.formatDateTime(dto.delivery_time);
    return {
      id: dto.id,
      amount: dto.quantity,
      deliveryTime: hour,
      deliveryTimeDate: date,
      providerDeliveryNote: dto.provider_delivery_note,
      plateNumber: dto.plate_number
    };
  }
}
